<template>
  <div>
    <div
      style="margin:.75rem .94rem;overflow: hidden;border: 1px solid #dedede;border-radius: 0.5rem;"
    >
      <div class="info-view">
        <div class="name">
          <span style="margin-left:1.25rem;font-size: .94rem;"
            >龙岩人民医院</span
          >
        </div>
        <div style="margin-left:.88rem;">
          <img :src="require('@assets/ic_position.png')" alt="" />
          <span
            style="width:100%;line-height:2.94rem;border-bottom: 1px solid #f2f2f2;"
            >地址：福州市五四路282号</span
          >
        </div>
        <div>
          <div>
            <div
              style="display: flex;width:100%;margin:.88rem .88rem 0 .88rem;"
            >
              <img :src="require('@assets/ic_phone_call.png')" alt="" />
              <span style="width:100%;border-bottom: 1px solid #f2f2f2;">
                电话：<a href="tel://0591-87878130">0591-87878130</a
                >（预约就诊）<br />&#12288;&#12288;&#12288;<a
                  href="tel://87878120"
                  >87878120</a
                >（急诊科)<br />&#12288;&#12288;&#12288;<a href="tel://87878201"
                  >87878201</a
                >（导诊台）
              </span>
            </div>
          </div>
        </div>
        <div style="margin-left:.88rem;">
          <img :src="require('@assets/ic_zip_code.png')" alt="" />
          <span
            style="width:100%;line-height:2.94rem;border-bottom: 1px solid #f2f2f2;"
            >邮编：350003</span
          >
        </div>
      </div>
    </div>
    <div
      style="margin:.75rem .94rem;overflow: hidden;border: 1px solid #dedede;border-radius: 0.5rem;"
    >
      <div class="info-view">
        <div class="name" style="background-color:#11ae91">
          <span style="margin-left:1.25rem;font-size: .94rem;"
            >福建易联众医疗信息系统有限公司</span
          >
        </div>
        <div style="margin-left:.88rem;">
          <img :src="require('@assets/ic_position.png')" alt="" />
          <span
            style="width:100%;line-height:2.94rem;border-bottom: 1px solid #f2f2f2;"
            >地址：福州市鼓楼区软件园G区6号楼</span
          >
        </div>
        <div>
          <div>
            <div style="display: flex;width:100%;margin:.88rem .88rem 0 .88rem">
              <img :src="require('@assets/ic_phone_call.png')" alt="" />
              <span style="width:100%;border-bottom: 1px solid #f2f2f2;">
                电话：<a href="tel://0591-88618271">0591-88618271</a
                ><br />&#12288;&#12288;&#12288;<a href="tel://0591-88618249"
                  >0591-88618249</a
                >
              </span>
            </div>
          </div>
        </div>
        <div style="margin-left:.88rem;">
          <img :src="require('@assets/ic_fax.png')" alt="" />
          <span
            style="width:100%;line-height:2.94rem;border-bottom: 1px solid #f2f2f2;"
            >传真：0591-83719729</span
          >
        </div>
        <div style="margin-left:.88rem;">
          <img :src="require('@assets/ic_zip_code.png')" alt="" />
          <span
            style="width:100%;line-height:2.94rem;border-bottom: 1px solid #f2f2f2;"
            >邮编：350003</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less">
.name {
  color: #fff;
  font-weight: 500;
  line-height: 4.5rem;
  background-color: #108eee;
}
.info-view {
  font-size: 0.88rem;

  > div {
    display: flex;
    align-items: center;
  }

  img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.5rem;
  }
}
</style>
